/* Membership in the logged-in customer's open Dolibarr orders.
 * Data is rendered by Shopify customer Liquid; no customer ID API parameter.
 */
(() => {
  if (window.lgOrderIndicatorLoaded) return;
  window.lgOrderIndicatorLoaded = true;
  const sourceSelector = '[data-lg-cart-product-id]';
  const badgeSelector = '[data-lg-order-product-id]';
  const orderIcon = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M14 3H6a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V8Z"/><path d="M14 3v5h5M8 11h6M8 14h3M11 17l2 2 4-4"/></svg><span class="lg-cart-indicator__tooltip" aria-hidden="true">On order</span>';
  let products = new Set();
  let expires = 0;
  let refreshing = null;

  function render() {
    document.querySelectorAll(sourceSelector).forEach(source => {
      const id = source.getAttribute('data-lg-cart-product-id');
      const host = source.parentElement;
      if (host.querySelector(badgeSelector)) return;
      const badge = source.cloneNode(false);
      badge.removeAttribute('data-lg-cart-product-id');
      badge.setAttribute('data-lg-order-product-id', id);
      badge.setAttribute('aria-label', 'On order');
      badge.classList.add('lg-order-indicator');
      badge.innerHTML = orderIcon;
      badge.hidden = true;
      host.appendChild(badge);
    });
    const fresh = Date.now() < expires;
    document.querySelectorAll(badgeSelector).forEach(badge => {
      const visible = fresh && products.has(badge.getAttribute('data-lg-order-product-id'));
      if (badge.hidden === visible) badge.hidden = !visible;
    });
  }

  function apply(data) {
    products = new Set();
    expires = 0;
    const status = data?.status;
    if (data?.customerId && status?.version === 1 && Array.isArray(status.products)) {
      const updated = Number(status.updated_at) * 1000;
      if (updated <= Date.now() + 60000 && updated > Date.now() - 5400000) {
        products = new Set(status.products.filter(id => /^\d+$/.test(String(id))).map(String));
        expires = updated + 5400000;
      }
    }
    render();
  }

  function refresh() {
    if (refreshing) return refreshing;
    refreshing = (async () => {
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}?section_id=lg-order-status`, {
          credentials:'same-origin', cache:'no-store', headers:{Accept:'text/html'}
        });
        if (!response.ok) throw Error('Status unavailable');
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const status = html.getElementById('lg-order-status');
        if (!status) throw Error('Missing status');
        apply(JSON.parse(status.textContent));
      } catch (_) {
        // Keep no customer data on a failed revalidation (e.g. logout).
        apply(null);
      }
    })().finally(() => { refreshing = null; });
    return refreshing;
  }

  function start() {
    try { apply(JSON.parse(document.getElementById('lg-order-status')?.textContent || 'null')); }
    catch (_) { apply(null); }
    new MutationObserver(records => {
      if (records.some(record => record.addedNodes.length)) render();
    }).observe(document.body, {childList:true,subtree:true});
    window.addEventListener('pageshow', refresh);
    window.addEventListener('focus', refresh);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') refresh();
    });
    setInterval(() => {
      render();
      if (document.visibilityState === 'visible') refresh();
    }, 120000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
